<template>
  <div class="chats">
    <div
      v-for="(grp, gIndex) in groupedMessages"
      :key="grp.key + '-' + gIndex"
      class="chat"
      :class="{ 'chat-left': grp.direction === 'in' }"
    >
      <div class="chat-avatar" v-if="grp.direction == 'in'">
        <b-avatar
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="light-secondary"
          :src="'https://rb.cloudedu.pro/studentPhoto/'+customerData.uuid+'.jpg'"
        />
      </div>

      <div class="chat-avatar" v-else>
        <b-avatar
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="primary"
        />
      </div>

      <div class="chat-body">
        <div
          v-for="m in grp.messages"
          :key="m.key"
          class="chat-content"
        >
          <div v-if="m.message_type == 'text'">
            <p class="tnc" v-if="m.text !== null" v-html="formatMessageText(m.text)"></p>
          </div>
          <div v-if="m.message_type == 'button'">
            <!-- <p class="tnc" v-if="m.text !== null" v-html="formatMessageText('按下 : ' + m.text)"></p> -->
            <b-badge v-if="m.text !== null" variant="primary" class="my-50 py-50 px-2">按下 :  {{ m.text }}</b-badge>
          </div>
          <div v-if="m.message_type == 'template_message'">
            <p>Marketing message: {{ m.text.replace(/^(api|normal|limited_time_offer|utility):\s*/i, '') }}</p>
          </div>

          <div v-if="m.message_type == 'image'">
            <img
              :src="'data:image/jpeg;base64,' + m.base64"
              class="image-small image-clickable"
              @click="openImageModal('data:image/jpeg;base64,' + m.base64)"
            />
          </div>

          <div v-if="m.message_type == 'video'">
            <video width="320" height="240" controls>
              <source :src="'data:video/mp4;base64,' + m.base64" type="video/mp4" />
            </video>
            <br />
            <!-- <a :href="m.display_url" class="image-small">Download</a> -->
          </div>

          <div v-if="m.message_type == 'audio'">
            <audio
              controls
              preload="metadata"
              style="width: 320px; height: 40px;"
            >
              <source :src="'data:audio/mp4;base64,' + m.base64" type="audio/mp4" />
              Your browser does not support the audio element.
            </audio>
            <br />
            <!-- <a
              :href="m.display_url"
              download
              class="image-small flex items-center gap-2 text-blue-600"
            >
              <i class="fa fa-download"></i>
              Download
            </a> -->
          </div>

          <div v-if="m.message_type == 'document'">
            <a :href="m.display_url" style="color:white;"><feather-icon icon="PaperclipIcon" size="24"/> Document</a>
          </div>

          <div v-if="m.message_type == 'sticker'">
            <img :src="'data:image/webp;base64,' + m.base64" class="image-small" />
          </div>

          <div v-if="m.message_type == 'interactivelist'">
            <div class="card-wrapper" v-if="m.interactive">
              <div class="whatsapp-card">
                <div class="card-content">
                  <div class="card-header">{{ m.interactive.header.text}}</div>
                  <div class="card-body">{{ m.interactive.body.text}}</div>
                  <div class="card-footer">{{ m.interactive.footer.text}}</div>
                </div>
                <div class="card-button" @click="toggleSection(gIndex)">
                  expand the list
                </div>
                {{visibleSections }}
                <div
                  class="card-section"
                  v-for="(section, sIndex) in m.interactive.action.sections"
                  :key="`${gIndex}-${sIndex}`"
                  v-show="!!visibleSections[gIndex]"
                >
                  <div class="section-title">{{ section.title }}</div>
                  <ul>
                    <li v-for="(row, rIndex) in section.rows" :key="`${gIndex}-${sIndex}-${rIndex}`">
                      {{ row.title }} <br /> {{ row.description }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-if="m.message_type == 'reply_button_media'">
            <div v-if="getFileExtension(m.text) == 'mp4'">
              <video width="320" height="240" controls><source :src="m.text" type="video/mp4" /></video>
            </div>
            <div v-else-if="getFileExtension(m.text) == 'jpg' || getFileExtension(m.text) == 'jpeg'">
              <a :href="m.text"><img :src="m.text" class="image-small" /></a>
            </div>
            <div v-else>
              <a :href="m.text"><img :src="m.text" class="image-small" /></a>
            </div>
          </div>

          <div v-else-if="m.message_type == 'reply_button_document'">
            <a :href="m.text" style="color:white;"><File class="w-6 h-6 text-blue-600" /> Download</a>
          </div>

          <div v-else-if="m.message_type == 'reply_button_url'">
            <div class="card-wrapper" v-if="m.text.interactive">
              <div class="whatsapp-card">
                <div class="card-content">
                  <div class="card-header">{{ m.text.interactive.header.text}}</div>
                  <div class="card-body">{{ m.text.interactive.body.text}}</div>
                  <div class="card-footer">{{ m.text.interactive.footer.text}}</div>
                </div>
                <div class="card-button">
                  <a :href="m.text.interactive.action.parameters.url">{{m.text.interactive.action.parameters.display_text}}</a>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="m.message_type == 'reply_button_text'">
            <div class="card-wrapper">
              <div class="whatsapp-card"><div class="card-content"><div class="card-body">{{ m.text }}</div></div></div>
            </div>
          </div>

          <div v-else-if="m.message_type == 'auto_reply_with_buttons'">
            <div class="card-wrapper" v-if="m.interactive">
              <div class="whatsapp-card">
                <div class="card-content"><div class="card-body">{{ m.text.interactive.body.text}}</div></div>
                <div class="card-button" v-for="button in m.text.interactive.action.buttons" :key="button.reply.id">
                  {{ button.reply.title }}
                </div>
              </div>
            </div>
          </div>

          <!-- optional: show failed reason -->
          
          <small class="msg-time text-right">
            {{ messageFormatDate(m.last_time) }} {{ m.user_name ?  m.user_name : '' }}
            <span class="ml-50">
              <font-awesome-icon v-if="m.status == 'failed'" icon="fa-solid fa-circle-xmark" class="text-danger fa-jello" />
              <font-awesome-icon v-if="m.status == 'delivered'" icon="fa-solid fa-circle-check" class="text-success" />
              <font-awesome-icon v-if="m.status == 'read'" icon="fa-solid fa-circle-check" class="text-success" />
              <font-awesome-icon v-if="m.status == 'sending'" icon="fa-solid fa-spinner" spin class="text-warning" />
            </span>
            <div v-if="m.status_message" class="text-danger text-bold">{{ m.status_message }}</div>
          </small>
          
        </div>
      </div>
      <div style="position:fixed;bottom:0px;right:0px;z-index:9999;"></div>
    </div>

    <div
      v-if="selectedImage"
      class="image-modal"
      @click="closeImageModal"
    >
      <div class="image-modal-content" @click.stop>
        <button type="button" class="image-modal-close" @click="closeImageModal">x</button>
        <img :src="selectedImage" class="image-preview" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.msg-time {
  display: block;          /* puts it on its own line */
  font-size: 11px;         /* smaller text */
  color: #9aa0a6;          /* light grey (WhatsApp-like) */
  margin-top: 4px;
}
.image-small { max-width: 15vw; max-height: 20vh;}
.image-clickable { cursor: zoom-in; }
.image-modal {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.8);
}
.image-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}
.image-modal-close {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  background: #fff;
  color: #222;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}
.image-preview {
  display: block;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
}
.card-wrapper { display: flex; justify-content: flex-end; padding: 10px; }
.whatsapp-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  max-width: 280px;
  overflow: hidden;
  font-family: sans-serif;
}

.card-header { font-weight: bold; padding: 10px 12px 2px; color:#888;}
.card-body { padding: 4px 12px; font-size: 14px; color:#888;}
.card-footer { color: #888; font-size: 12px; padding: 4px 12px;}

.card-button {
  border-top: 1px solid #eee;
  color: #2a5271; /* WhatsApp Green */
  text-align: center;
  padding: 10px;
  cursor: pointer;
  font-weight: 500;
}

.card-section {
  background: #f9f9f9;
  border-top: 1px solid #eee;
  padding: 10px;
}

.section-title {
  font-size: 12px;
  color: black;
  text-transform: uppercase;
  margin-bottom: 5px;
}

ul { list-style: none; padding: 0; margin: 0; }
li { padding: 8px 0; border-bottom: 1px solid #eee; font-size: 14px; color:#667781;}
li:last-child { border-bottom: none; }
</style>

<script>
import { computed, ref } from '@vue/composition-api'
import { BAvatar,BBadge } from 'bootstrap-vue'

export default {
  components: { BAvatar,BBadge },

  props: {
    // parent passes conversations (array)
    chatData: {
      type: Array,
      required: true,
    },
    customerData: {
      type: Object,
      required: false
    },
  },

  setup(props) {
    function escapeHtml(text) {
      return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    }

    function formatMessageText(text) {
      const safeText = escapeHtml(String(text || ''))
      const withBold = safeText.replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>')
      return withBold.replace(/\r?\n/g, '<br>')
    }

    function messageFormatDate(delivery_datetime){
      if (!delivery_datetime) return '';
      const date = new Date(delivery_datetime);
     // date.setHours(date.getHours() - 8);
      const now = new Date();
      const inputMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const diffInDays = Math.floor((nowMidnight - inputMidnight) / (1000 * 60 * 60 * 24));
      const timeStr = date.toTimeString().slice(0, 5);
      if (diffInDays === 0) return timeStr;
      if (diffInDays === 1) return `Yesterday ${timeStr}`;
      if (diffInDays === 2) return `2 days ago ${timeStr}`;
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd} ${timeStr}`;
    }

    function getFileExtension(url) {
      const pathname = new URL(url).pathname;
      const lastSegment = pathname.split('/').pop();
      const ext = lastSegment.split('.').pop().toLowerCase();
      return ext;
    }
    const visibleSections = ref({})
    const selectedImage = ref('')

    function openImageModal(imageSrc) {
      selectedImage.value = imageSrc || ''
    }

    function closeImageModal() {
      selectedImage.value = ''
    }

    function toggleSection(index) {
      visibleSections.value = {
        ...visibleSections.value,
        [index]: !visibleSections.value[index],
      }
    }
    // 1) sort messages by time (your API returns last_time / send_time / receive_time)
    const sortedMessages = computed(() => {
      const arr = Array.isArray(props.chatData) ? props.chatData : []
      return [...arr]
        .map((m, i) => {
          const t = m.send_time || m.receive_time || m.last_time || ''
          return { ...m, _t: t, _i: i }
        })
        .sort((a, b) => String(a._t).localeCompare(String(b._t)))
    })

    // 2) group consecutive messages by direction (in/out)
    const groupedMessages = computed(() => {
      const items = sortedMessages.value
      const groups = []
      let current = null

      for (let i = 0; i < items.length; i++) {
        const msg = items[i]
        const direction = msg.direction === 'out' ? 'out' : 'in'

        const packed = {
          key: `${msg.message_id || msg.id || 'msg'}-${msg._t || 'no-time'}-${msg._i}-${i}`,
          text: msg.message ?? '',
          time: msg._t,
          delivery_status: msg.delivery_status,
          status_message: msg.status_message,
          status: msg.status,
          base64: msg.base64,
          file_url: msg.file_url,
          message_type: msg.message_type,
          display_url:msg.display_url,
          interactive:msg.message.interactive,
          last_time: msg.last_time,
          user_name: msg.user_name,
        }

        if (!current) {
          current = {
            key: `${direction}-${packed.key}`,
            direction,
            messages: [packed],
          }
          continue
        }

        if (current.direction === direction) {
          current.messages.push(packed)
        } else {
          groups.push(current)
          current = {
            key: `${direction}-${packed.key}`,
            direction,
            messages: [packed],
          }
        }
      }

      if (current) groups.push(current)
      return groups
    })

    return {
      groupedMessages,
      selectedImage,
      openImageModal,
      closeImageModal,
      toggleSection,
      visibleSections,
      getFileExtension,
      messageFormatDate,
      formatMessageText,
    }
  },
}
</script>